import { render, staticRenderFns } from "./Sister.vue?vue&type=template&id=3ca0bf40&"
import script from "./Sister.vue?vue&type=script&lang=js&"
export * from "./Sister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports